module.exports = __webpack_public_path__ + "../resources/images/progress-e4ba8e5c7eb8b6080aadb62c29bbf737.gif";